import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { 
  Container, 
  Header, 
  HeaderLeft, 
  BackButton, 
  Title, 
  Content, 
  MainSection
} from '../common/styles';
import InstantFeedback from '../EmployeesRepository/EmployeeForm/components/InstantFeedback';
import { useAuth } from '../../contexts/AuthContext';
import { useAlert } from '../../contexts/AlertContext';
import LoadingSpinner from '../common/LoadingSpinner';
import EmptyState from '../common/EmptyState';

const MyInstantFeedbacks = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(true);
  const [employeeId, setEmployeeId] = useState(null);

  useEffect(() => {
    if (user?.employee?.id) {
      setEmployeeId(user.employee.id);
      setLoading(false);
    } else {
      showAlert('User information not found', 'error');
      setLoading(false);
    }
  }, [user, showAlert]);

  const handleBack = () => {
    navigate('/');
  };

  return (
    <Container>
      <Header>
        <HeaderLeft>
          <BackButton onClick={handleBack}>
            <FaArrowLeft /> Back to Home
          </BackButton>
          <Title>My Instant Feedbacks</Title>
        </HeaderLeft>
      </Header>
      <Content>
        <MainSection>
          {loading ? (
            <LoadingSpinner />
          ) : employeeId ? (
            <InstantFeedback employeeId={employeeId} />
          ) : (
            <EmptyState 
              title="Unable to load instant feedbacks" 
              description="Individual information not found. Please try again later or contact support." 
            />
          )}
        </MainSection>
      </Content>
    </Container>
  );
};

export default MyInstantFeedbacks; 